import NumberFilter from "@search/store/filters/primitive/NumberFilter";

const defaultValue: number = 1;

class PageFilter extends NumberFilter {
  constructor(value: number) {
    super({ defaultValue, name: "page", value });
  }
}

export default PageFilter;
export { PageFilter };
